import { FormattedMessage } from 'react-intl'

import TimerSVG from 'app/assets/icons/listing/timer.svg'
import TrianglesSVG from 'app/assets/icons/listing/triangles-auction-hint.svg'
import Box from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import ChipLabel from 'app/components/common/ChipLabel'
import FormattedEndDate from 'app/components/common/FormattedEndDate'

const AuctionEndHint: RFC<{
  auctionEndDate?: string
}> = ({ auctionEndDate }) => {
  const endDate = new Date(auctionEndDate || '')

  return (
    <ChipLabel sx={{ mb: { xs: 2 } }}>
      <Stack
        direction="row"
        spacing={1.25}
        sx={{
          position: 'relative',
          px: 1.25,
          py: 2,
          borderRadius: 1.25
        }}
      >
        <TimerSVG />

        <Stack>
          <Text variant="body2" sx={{ fontWeight: 500 }}>
            <FormattedMessage defaultMessage="Auction ends in:" />
          </Text>

          <Text color="primary.main">
            <FormattedEndDate endDate={endDate} />
          </Text>
        </Stack>

        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0
          }}
        >
          <TrianglesSVG />
        </Box>
      </Stack>
    </ChipLabel>
  )
}

export default AuctionEndHint
